<template>
    <div class="newsItem" :class="{sanTu: result.type == 'sanTu', daTu: result.type == 'daTu'}">
        
        <!--  :class="{loding: typeof result != 'object'}" -->
        <div class="loadingBox">
            <!-- <transition-group
                name="list"
                tag="div"
                :css="false"
                @before-enter="beforeEnter"
                @enter="enter"
                @leave="leave"
            > -->
            
                <div class="animationBox" :class="{sanTu: result.type == 'sanTu', daTu: result.type == 'daTu'}" v-if="typeof result == 'object'" :key="dataIndex + 'animation'" @click="newsSkip(result)">
                    <template v-if="result.type == 'sanTu'">
                        <div class="newsTitle">{{ result.title }}</div>
                        <div class="newsHeadImageList">
                            <img :src="i" v-for="(i, index) in result.thumbnailUrls" :key="'sanTu' + index">
                        </div>
                        <div class="newsContentBot ellipsis">
                            <span>{{ result.publishTimeCaption }}</span>
                            <span>{{ result.commentsCountCaption }}</span>
                            <span>{{ result.authorName }}</span>
                        </div>
                    </template>
                    <template v-else-if="result.type == 'daTu'">
                        <div class="newsTitle">{{ result.title }}</div>
                        <div class="newsHeadImage-daTu">
                            <img :src="result.thumbnailUrls[0]">
                        </div>
                        <div class="newsContentBot ellipsis">
                            <span>{{ result.publishTimeCaption }}</span>
                            <span>{{ result.commentsCountCaption }}</span>
                            <span>{{ result.authorName }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="newsContent">
                            <p class="ellipsis-2">{{ result.title }}</p>
                            <p class="ellipsis"><span>{{ result.publishTimeCaption }}</span><span>{{ result.commentsCountCaption }}</span><span>{{ result.authorName }}</span></p>
                        </div>
                        <div class="newsHeadImage" v-if="result.thumbnailUrls.length > 0">
                            <img :src="result.thumbnailUrls[0]">
                        </div>
                    </template>

                </div>

            <!-- </transition-group> -->
        </div>

    </div>
</template>
<script>
import statistical from "../assets/js/statistical";
export default {
    name: "newsItem",
    props:{
        result: {
            type: [Object, Number],
            default: 0
        },
        dataIndex:{}
    },
    methods: {
        newsSkip(listElement){
            // 1，打开内容：
            let a = document.createElement("a");
            {
                a.href = listElement.contentUrl;
                a.target = "_blank";
            }
            a.click();
            a.remove();

            // 2，报送统计：
            statistical.statisticContent(listElement.id, listElement.statisticsRecordId_GSAppNodeId);
            statistical.getTotalHits(listElement.id);
        },
        beforeEnter: function (el) {
			el.style.opacity = 0
		},
		enter: function (el, done) {
            let that = this;
			var delay = this.dataIndex * 130;
			setTimeout(function () {
				that.$Velocity(
				el,
				{ opacity: 1},
				{ complete: done, duration: 500 }
				)
			}, delay)
		},
		leave: function (el, done) {
            let that = this;
			var delay = this.dataIndex * 130; 
			setTimeout(function () {
				that.$Velocity(
				el,
				{ opacity: 0 },
				{ complete: done, duration: 500 }
				)
			}, delay)
		}
    },
}
</script>
<style lang="scss" scoped>
    .newsItem{
        position: relative;
        padding: 12px 16px;
        min-height: 100px;
        width: 100%;
        box-sizing: border-box;
        // &.sanTu{
        //     height: auto;
        // }
        &::after{
            content: "";
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: calc(100% - 32px);
            height: 0.5px;
            @include newsItemAfter_Background($newsItemAfter_Background);
        }
        &:last-of-type {
            &::after{
                display: none;
            }
        }
        .loadingBox{
            width: 100%;
            height: 100%;
            background-color: transparent;
            transition: all .1s;
            // 鱼骨色块
            &.loding{
                @include loding_Background($loding_Background);
                border-radius: 4px;
                animation: lodingColor 2s ease-in-out infinite;
            }
            // 动画执行块
            .animationBox{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                height: 100%;
                &.sanTu{
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                }
                &.daTu{
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                }
                .newsTitle{
                    font-size: 15px;
                    // color: #222;
                    @include newsContentColor($newsContentColor);
                    line-height: 24px;
                    margin-bottom: 8px;
                    font-weight: 500;
                }
                .newsContent{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 0;
                    flex: 1;
                    font-size: 15px;
                    @include newsContentColor($newsContentColor);
                    line-height: 24px;
                    p{
                        &:first-of-type{
                            margin-bottom: 7px;
                        }
                        &:last-of-type{
                            font-size: 11px;
                            @include newsTimeColor($newsTimeColor);
                            line-height: 18px;
                            span{
                                display: inline-block;
                                margin-right: 12px;
                                &:last-of-type{
                                    margin: 0;
                                    max-width: 110px;
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                }
                            }
                        }
                    }
                }
                .newsContentBot{
                    width: 100%;
                    font-size: 11px;
                    color: #999;
                    line-height: 18px;
                    span{
                        margin-right: 12px;
                        &:last-of-type{
                            margin: 0;
                        }
                    }
                }
                .newsHeadImageList{
                    display: flex;
                    align-items: center;
                    height: 72px;
                    width: 100%;
                    margin-bottom: 12px;
                    border-radius: 6px;
                    overflow: hidden;
                    img{
                        display: block;
                        height: 72px;
                        width: 0;
                        flex: 1;
                        margin-right: 4px;
                        overflow: hidden;
                        &:last-of-type{
                            margin: 0;
                        }
                    }
                }
                .newsHeadImage-daTu{
                    width: 100%;
                    margin-bottom: 10px;
                    img{
                        display: block;
                        height: 158px;
                        width: 100%;
                        object-fit: cover;
                        overflow: hidden;
                        border-radius: 6px;
                    }
                }
            }
            .newsHeadImage{
                width: 112px;
                height: 72px;
                overflow: hidden;
                border-radius: 6px;
                margin-left: 12px;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
</style>